import React, { useState } from 'react';
import {
  ASSET_TYPE,
  AssetItem,
  LiabilityItem,
  REPORT_ITEM_TYPE,
  ReportItemType,
} from '../../type/AssetReport.type';
import { ASSET_REPORT_LABEL } from '../../../../common/comstant/LabelConstants';
import { numberWithCommas } from '../../../../common/util/NumberUtils';
import { useAppStateCurrentAssetReportStore } from '../../../../common/store/AppStateStore.zustand';

export interface AssetReportItemTableModalData {
  isOpen: boolean;
  reportItemType: ReportItemType;
  onClose: () => void;
}

const AssetReportItemTableModal = ({ isOpen, reportItemType, onClose }: AssetReportItemTableModalData) => {
  const { currentAssetReport } = useAppStateCurrentAssetReportStore();
  const reportItemList =
    currentAssetReport?.reportItemList.filter((reportItem) => reportItem.type == reportItemType) ?? [];
  const [showCategory2Filter, setShowCategory2Filter] = useState<boolean>(false);
  const [selectedCategory2Filter, setSelectedCategory2Filter] = useState<string>();
  const handleCloseClick = () => {
    onClose();
  };

  return isOpen ? (
    <div className="fixed min-h-screen inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ">
      <div className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold text-gray-800">{ASSET_REPORT_LABEL[reportItemType]} 목록</h2>
            <button onClick={handleCloseClick} className="text-gray-400 hover:text-gray-600">
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>
        <div className="border-t border-gray-200">
          <div className="p-6">
            <div className="overflow-x-auto">
              <table className="w-full table-fixed divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-2 py-2 w-14 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      구분1
                    </th>
                    <th
                      scope="col"
                      className="px-2 py-2 w-20 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      구분2
                      {/*<button*/}
                      {/*  onClick={() => setShowCategory2Filter((prev) => !prev)}*/}
                      {/*  className="ml-1 text-gray-500 hover:text-gray-700"*/}
                      {/*>*/}
                      {/*  <i className="fas fa-filter"></i>*/}
                      {/*</button>*/}
                      {/*{showCategory2Filter && (*/}
                      {/*  <div className="absolute top-full left-0 mt-1 bg-white rounded-md shadow-lg z-50 min-w-[160px]">*/}
                      {/*    <div className="py-1">*/}
                      {/*      <button*/}
                      {/*        onClick={() => {*/}
                      {/*          setSelectedCategory2Filter(undefined);*/}
                      {/*          setShowCategory2Filter(false);*/}
                      {/*        }}*/}
                      {/*        className={`block px-4 py-2 text-sm text-left hover:bg-gray-100 ${selectedCategory2Filter === '전체' ? 'bg-blue-50 text-blue-600' : 'text-gray-700'}`}*/}
                      {/*      >*/}
                      {/*        전체*/}
                      {/*      </button>*/}
                      {/*      {(reportItemType === REPORT_ITEM_TYPE.ASSET*/}
                      {/*        ? ASSET_TYPE_OPTION_LIST*/}
                      {/*        : LIABILITY_TYPE_OPTION_LIST*/}
                      {/*      ).map((option) => (*/}
                      {/*        <button*/}
                      {/*          onClick={() => {*/}
                      {/*            setSelectedCategory2Filter(option.value);*/}
                      {/*            setShowCategory2Filter(false);*/}
                      {/*          }}*/}
                      {/*          className={`block px-4 py-2 text-sm text-left hover:bg-gray-100 ${selectedCategory2Filter === option.value ? 'bg-blue-50 text-blue-600' : 'text-gray-700'}`}*/}
                      {/*        >*/}
                      {/*          {option.label}*/}
                      {/*        </button>*/}
                      {/*      ))}*/}
                      {/*    </div>*/}
                      {/*  </div>*/}
                      {/*)}*/}
                    </th>
                    <th scope="col" className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase ">
                      이름
                    </th>
                    <th
                      scope="col"
                      className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      금액
                    </th>
                    {reportItemType === REPORT_ITEM_TYPE.ASSET && (
                      <th
                        scope="col"
                        className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        원금
                      </th>
                    )}
                    {reportItemType === REPORT_ITEM_TYPE.ASSET && (
                      <th
                        scope="col"
                        className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        배당금
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {reportItemList.length > 0 ? (
                    reportItemList
                      .filter(
                        (reportItem) =>
                          !selectedCategory2Filter ||
                          (reportItem.type === REPORT_ITEM_TYPE.ASSET
                            ? (reportItem as AssetItem).assetType
                            : (reportItem as LiabilityItem).liabilityType) === selectedCategory2Filter,
                      )
                      .sort((item1, item2) => item2.amount - item1.amount)
                      .map((reportItem, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-2 py-2 break-words text-xs text-center font-medium text-gray-500 ">
                            {ASSET_REPORT_LABEL[reportItem.type]}
                          </td>
                          <td className="px-2 py-2 break-words text-xs text-center font-medium text-gray-500 ">
                            {
                              ASSET_REPORT_LABEL[
                                reportItem.type === REPORT_ITEM_TYPE.ASSET
                                  ? (reportItem as AssetItem).assetType
                                  : (reportItem as LiabilityItem).liabilityType
                              ]
                            }
                          </td>

                          <td className="px-2 py-2 break-words text-xs font-medium text-gray-500 ">
                            {reportItem.name}
                          </td>
                          <td className="px-2 py-2 break-words text-xs font-medium text-gray-500 ">
                            {numberWithCommas(reportItem.amount)} 원
                          </td>
                          {reportItemType === REPORT_ITEM_TYPE.ASSET && (
                            <td className="px-2 py-2 break-words text-xs font-medium text-gray-500 ">
                              {(reportItem as AssetItem).assetType === ASSET_TYPE.INVESTMENT
                                ? numberWithCommas((reportItem as AssetItem).principalAmount) + ' 원'
                                : ''}
                            </td>
                          )}
                          {reportItemType === REPORT_ITEM_TYPE.ASSET && (
                            <td className="px-2 py-2 break-words text-xs font-medium text-gray-500 ">
                              {(reportItem as AssetItem).assetType === ASSET_TYPE.INVESTMENT
                                ? numberWithCommas(Number((reportItem as AssetItem).dividendAmount) || 0) + ' 원'
                                : ''}
                            </td>
                          )}
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td
                        className="px-2 py-2 break-words text-sm text-gray-500"
                        colSpan={reportItemType === REPORT_ITEM_TYPE.ASSET ? 6 : 5}
                      >
                        데이터가 없습니다.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default AssetReportItemTableModal;
